module.exports = __webpack_public_path__ + "static/media/Shipping.082ce7e6.jpeg";